"use strict";
exports.__esModule = true;
exports.languagePack = void 0;
var zh_CN_1 = require("./zh-CN");
var en_US_1 = require("./en-US");
var ja_JP_1 = require("./ja-JP");
var de_DE_1 = require("./de-DE");
var zh_TW_1 = require("./zh-TW");
var languagePack = {
    'zh-CN': zh_CN_1["default"],
    'en-US': en_US_1["default"],
    'ja-JP': ja_JP_1["default"],
    'de-DE': de_DE_1["default"],
    'zh-TW': zh_TW_1["default"]
};
exports.languagePack = languagePack;
;
exports["default"] = languagePack;
